import { ACCESS_TOKEN, REFRESH_TOKEN } from "~/enum/cache/cookie";
import { useMainStore } from "~/stores";
import Cookie from "~/utils/cookie";

// 缓存请求
export function useRefreshToken() {
  let promise: any = null;

  function refreshToken() {
    if (promise) {
      return promise;
    }

    promise = new Promise((resolve) => {
      // 刷新token
      const r_tk = Cookie.get(REFRESH_TOKEN);
      if (r_tk) {
        const mainStore = useMainStore();
        const $api = useApi();

        // 使用 Nuxt 应用实例获取 API
        $api
          .refreshTokenFn({
            refreshToken: r_tk,
          })
          .then((res) => {
            mainStore.setToken(res?.accessToken);
            mainStore.setRefreshToken(res?.refreshToken);
            resolve(res);
          })
          .catch(() => {
            Cookie.remove(ACCESS_TOKEN);
            Cookie.remove(REFRESH_TOKEN);
          })
          .finally(() => {
            promise = null;
          });
      } else {
        Cookie.remove(ACCESS_TOKEN);
        Cookie.remove(REFRESH_TOKEN);
      }
    });

    promise.finally(() => {
      promise = null;
    });

    return promise;
  }

  return {
    refreshToken,
  };
}
